export const ERROR_TYPE_MESSAGES: Record<string, string> = {
  token_refresh: "Token refresh failed. The EHR client ID may be incorrect or the patient needs to re-link their account.",
  auth: "Authorization rejected by EHR. The client ID may be invalid or permissions have changed.",
  not_found: "Some FHIR resources were not found. This may be normal if the patient has limited records.",
  timeout: "EHR server took too long to respond.",
  other: "Some record fetches failed.",
};
